import { addDays, isBefore } from 'date-fns';

export type RegistrationBannerIdRecord = {
  bannerId: string;
  createdAt: Date;
};

export type RegistrationBannerIdUpdate = 'set' | 'keep' | 'delete';

export const welcomeOfferBannerId: string = '4321';

export const registrationBannerIdStorageKey: string = 'registration-banner-id';

const registrationBannerIdValidityInDays: number = 7;

const registrationSelectionFragmentPrefix: string = 'modal-register-selection$';

export function isRegistrationBannerIdRecordValid(
  record: RegistrationBannerIdRecord | undefined,
  now: Date = new Date()
): record is RegistrationBannerIdRecord {
  return Boolean(record && isBefore(now, addDays(record.createdAt, registrationBannerIdValidityInDays)));
}

export function resolveRegistrationBannerIdUpdate(
  storedRecord: RegistrationBannerIdRecord | undefined,
  incomingBannerId: string | undefined,
  now: Date = new Date()
): RegistrationBannerIdUpdate {
  if (!incomingBannerId) {
    return 'delete';
  }

  if (isRegistrationBannerIdRecordValid(storedRecord, now) && storedRecord.bannerId === incomingBannerId) {
    return 'keep';
  }
  return 'set';
}

export function extractRegistrationBannerIdFromFragment(fragment: string): string | undefined {
  const normalizedFragment: string = fragment.startsWith('#') ? fragment.slice(1) : fragment;
  if (!normalizedFragment.startsWith(registrationSelectionFragmentPrefix)) {
    return undefined;
  }
  return normalizedFragment.slice(registrationSelectionFragmentPrefix.length) || undefined;
}
